/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_Section_TripsInputs */

const vi_station_work_section_trips = /** @type {(inputs: Station_Work_Section_TripsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang công tác`)
};

/**

* @param {Station_Work_Section_TripsInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_section_trips = /** @type {((inputs?: Station_Work_Section_TripsInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Section_TripsInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_section_trips(inputs)
});